import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const SectorCommunication = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default SectorCommunication